import {
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';

import { AuthService } from 'src/app/services/auth.service';
import { ManufacturerPopoversService } from 'src/app/services/shared/manufacturer-popovers.service';
import { OpenModalService } from 'src/app/services/shared/open-modal.service';
import { SupplierOrders } from 'src/app/models/supplier-portal/supplier/supplierOrders.models';
import { OrderSupplierService } from 'src/app/services/portal-supplier/order-supplier.service';
import { ProcessingComponent } from './processing/processing.component';

type ManufacturerOrderView =
  | 'history'
  | 'nonConforming'
  | 'inProgress'
  | 'partial';

interface ManufacturerOrderRow {
  orderNumber: string;
  supplier: string;
  expectedDate: Date;
  orderDate: Date;
  processStage: string;
  articles: number;
}

interface ManufacturerTab {
  key: ManufacturerOrderView;
  label: string;
  icon: string;
  background: string;
}

@Component({
  selector: 'app-manufacturer-list',
  standalone: false,
  templateUrl: './manufacturer-list.component.html',
  styleUrls: ['./manufacturer-list.component.scss'],
})
export class ManufacturerListComponent implements OnInit, OnDestroy {
  @ViewChild(ProcessingComponent) child!: ProcessingComponent;

  private authService = inject(AuthService);

  private readonly onPopState = (): void => {
    history.pushState(null, '', location.href);
  };

  public readonly pageSize = 20;
  public readonly rowHeight = 44;
  public readonly tabs: ManufacturerTab[] = [
    {
      key: 'inProgress',
      label: 'Ordini in lavorazione',
      icon: 'bx bx-loader-alt',
      background: 'color-processing',
    },
    {
      key: 'partial',
      label: 'Ordini parziali',
      icon: 'bx bx-git-branch',
      background: 'color-partial',
    },
    {
      key: 'history',
      label: 'Storico ordini',
      icon: 'bx bx-history',
      background: 'color-history',
    },
  ];

  accountId: number = null;
  user: any;

  public Order: SupplierOrders.IOrder[] = [];
  public activeTab: ManufacturerOrderView = 'inProgress';
  public firstEnteredOnPage = true;
  public filterTerm = '';
  public filteredOrders: ManufacturerOrderRow[] = [];
  modifyBtn: string;
  currentYear = new Date().getFullYear();

  public mServ = inject(ManufacturerPopoversService);
  public authServ = inject(AuthService);
  public closeSrv = inject(OpenModalService);
  private readonly orderSupplierService = inject(OrderSupplierService);
  private cdr = inject(ChangeDetectorRef);
  loading: boolean = false;

  public ngOnInit(): void {
    this.user = this.authService.currentUserValue;

    const tab = (history.state?.['tab'] as ManufacturerOrderView) ?? 'inProgress';

    history.pushState(null, '', location.href);
    window.addEventListener('popstate', this.onPopState);

    if (!this.firstEnteredOnPage) {
      return;
    }
    this.accountId = this.authServ.currentUserSubject.value?.account_id;
    this.firstEnteredOnPage = false;
    this.setActiveTab(tab);
  }

  public ngOnDestroy(): void {
    window.removeEventListener('popstate', this.onPopState);
  }

  public clearSearch(): void {
    this.filterTerm = '';
  }

  public addOrder(order_number: string) {
    const supplierAccount = this.orderSupplierService.suplierDetails;
    console.log('supplier is ', supplierAccount);

    const payload: SupplierOrders.IAddNewOrderFromGamma = {
      supplier_id: supplierAccount?.supplier?.supplier_id,
      supplier_code: supplierAccount?.supplier?.code,
      order_number: order_number,
    };
    this.orderSupplierService.addNewOrder(payload).subscribe((response) => {
      console.log('Response from addNewOrder', response);
      if (!response) {
        this.mServ.serverErrorSwal();
        return;
      }
      if (response?.error_message?.msg_code == 0) {
        this.mServ.addedOrderSwal();
        this.resetOrderCount();
        this.child?.getList();
      } else if (response?.error_message?.msg_code == 8) {
        this.mServ.noOrderFoundSwal();
      } else this.mServ.serverErrorSwal();
    });
  }

  public setActiveTab(tab: ManufacturerOrderView): void {
    if (tab === this.activeTab) return;
    this.resetOrderCount();
    this.loading = !this.loading;
    this.activeTab = tab;
  }

  public isCurrentTab(tab: ManufacturerOrderView): boolean {
    return this.activeTab === tab;
  }

  public get totalOrdersToCheck() {
    return this.orderSupplierService.orderNumberCounter.asObservable();
  }

  resetOrderCount() {
    this.orderSupplierService.orderNumberCounter.next(0);
  }

  public get currentSectionLabel(): string {
    return this.tabs.find((tab) => tab.key === this.activeTab)?.label ?? '';
  }

  public get totalOrdersLabel(): string {
    switch (this.activeTab) {
      case 'history':
        return 'TOTALE ORDINI COMPLETATI';
      case 'nonConforming':
        return 'TOTALE ORDINI NON CONFORMI';
      case 'partial':
        return 'TOTALE ORDINI IN LAVORAZIONE (parziali)';
      case 'inProgress':
      default:
        return 'TOTALE ORDINI IN LAVORAZIONE';
    }
  }

  public changePassword(): void {
    this.modifyBtn = this.authServ.currentUserSubject.value?.account_id;
    this.closeSrv.openPass();
  }

  logout() {
    this.mServ.logoutSwal();
    this.authServ.logout();
  }

  openProfile(event: any) {
    this.mServ
      .openProfilePage(
        event,
        this.authServ?.currentUserSubject?.value?.ac_email,
      )
      .then((result: any) => {
        if (result?.data == 'password') {
          this.changePassword();
        }
        if (result?.data == 'logout') {
          this.logout();
        }
      });
  }

  openLegend() {
    this.mServ.openLegend();
  }
}
